export default "__VITE_PUBLIC_ASSET__61a2a9c5__"